import {FnaQuestionnaireAnswers} from '../fna';
import {QuestionId} from '../insurance/question-id';
import {QuestionnaireId} from '../insurance/questionnaire-id';
import {QuestionnaireAnswers} from '../questionnaire';
import {HealthAnswers} from '../questionnaire/health-answers';
import {Answer, TranslatedAnswer} from './answer';
import {SubtextType, TextTranslations} from './utils';

export interface UiQuestion<T extends QuestionnaireAnswers | FnaQuestionnaireAnswers = HealthAnswers> {
  id: QuestionId;
  text: TextTranslations;
  answer: Answer<T>;
  subtexts?: Subtext[];
  extraQuestionnaire?: QuestionnaireId;
  causesIneligibility?: boolean;
}

interface Subtext {
  type: SubtextType;
  value: TextTranslations;
}

export interface TranslatedUiQuestion<
  T extends QuestionnaireAnswers | FnaQuestionnaireAnswers = HealthAnswers,
> {
  id: QuestionId;
  text: string;
  answer: TranslatedAnswer<T>;
  subtexts?: TranslatedSubtext[];
  extraQuestionnaire?: QuestionnaireId;
  causesIneligibility?: boolean;
}

export interface TranslatedSubtext {
  type: SubtextType;
  value: string;
}

export function areNewAndOldQuestionsIdentical(
  newQuestions: TranslatedUiQuestion[],
  oldQuestions: TranslatedUiQuestion[],
): boolean {
  if (oldQuestions.length !== newQuestions.length) {
    return false;
  }

  const map = new Map<string, TranslatedUiQuestion>();
  oldQuestions.forEach((q) => map.set(q.id, q));

  for (const newQuestion of newQuestions) {
    const oldQuestion = map.get(newQuestion.id);
    if (!oldQuestion) {
      return false;
    }

    if (
      oldQuestion.text !== newQuestion.text ||
      JSON.stringify(oldQuestion.subtexts) !== JSON.stringify(newQuestion.subtexts)
    ) {
      return false;
    }
  }

  return true;
}
